/**
 * Модуль абстракции хранилища
 *
 * Предоставляет унифицированный интерфейс для работы с хранилищем данных.
 * Поддерживает IndexedDB (предпочтительно) и localStorage (fallback).
 *
 * Преимущества IndexedDB:
 * - Большой объём хранения (ограничен только диском)
 * - Асинхронный API (не блокирует UI)
 * - Поддержка структурированных данных
 * - Транзакции
 */

export {
  createStorage,
  createIndexedDBStorage,
  createLocalStorageStorage,
  isIndexedDBAvailable,
  migrateFromLocalStorage,
  type StateStorage,
} from './indexedDB';

/** Имя базы данных IndexedDB для приложения */
export const DB_NAME = 'git-lessons-db';

/** Имена хранилищ (object stores) */
export const STORE_NAMES = {
  PROGRESS: 'progress',
  REPO: 'repo',
} as const;
